export enum UserFeatures {
  FORWARD_TRADE_ENABLED = "forwardTradeEnabled",
}
export type OktaProfileFeatures = { [UserFeatures.FORWARD_TRADE_ENABLED]: boolean };
export type UseOktaProfileFeatures = () => { oktaProfileFeatures: OktaProfileFeatures };
